<template>
  <div class="main-banner-wrapper">

    <TheHeader fontClass="fontColor1"/>

    <!-- Content 1 -->
    <div class="main-title-wrapper">
      <div class="poppins-medium title-wrapper fontColor1">
        <span class="poppins-bold">Connection</span> or <span class="poppins-bold">Cooperative</span>
        <br/>
        link between people,organizations & government
      </div>
      <div class="button-wrapper">
        <div class="poppins-medium btn-font-size buttonStyle1 fontColor2">
          <router-link to="/news-event" style="text-decoration: none;" class="fontColor2"><span>News</span></router-link>
        </div>
        <div class="poppins-medium btn-font-size buttonStyle2 fontColor1">
          <router-link to="/contact-us" style="text-decoration: none;" class="fontColor1"><span>Contact Us</span></router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Content 2 -->
  <div class="content-two-wrapper">
    <!-- <div class="montserrat-600 sub-text-one">SPECIALISED CRANE & HAULAGE SERVICE</div> -->
    <div class="poppins-bold sub-text-two fontColor2">EXPERTISE</div>
    <div class="montserrat-600 sub-text-one max-width sub-text-three">
      Empowering the industry through Resources, Training, and Safety, 
      built on strong connections with stakeholders and government to drive sustainable growth.
    </div>
    <div class="about-icn-wrapper montserrat-600 sub-text-one fontColor2">
      <div class="icn-wrapper">
        <img alt="LIFT EXPERTS" src="../assets/images/icon-01.png"/>
        <div>RESOURCES</div>
      </div>
      <div class="icn-wrapper">
        <img alt="LIFT EXPERTS" src="../assets/images/icon-02.png"/>
        <div>TRAINING</div>
      </div>
      <div class="icn-wrapper">
        <img alt="LIFT EXPERTS" src="../assets/images/icon-03.png"/>
        <div>SAFETY</div>
      </div>
    </div>
    <div class="poppins-medium btn-font-size buttonStyle1" style="margin: 13px auto 0 auto;">
      <router-link to="/about" style="text-decoration: none;" class="fontColor2"><span>Learn More</span></router-link>
    </div>
  </div>

  <!-- Content 3 -->
  <div class="content-three-wrapper">
    <div class="montserrat-600 sub-text-one">THE LATEST IN LIFTING MATTERS</div>
    <div class="poppins-bold sub-text-two fontColor2">News & Insights</div>
    <br/>
    <div class="montserrat-600 sub-text-one max-width sub-text-three">
      <router-link to="/news-event"><span style="color: #666666;">MORE NEWS</span></router-link>
    </div>
    <br/>
    <div class="news-wrapper montserrat-600">
      <div class="news-style" v-for="(news, index) in newsList" :key="index">
        <img :src="news.img" alt="LIFT EXPERTS" />
        <div>{{ news.date }}</div>
        <div class="fontColor2 front-news">{{ news.title }}</div>
        <div class="montserrat-400 btn-font-size buttonStyle1 news-btn" style="text-align: center; font-size: 13px;">
          <router-link :to="news.link">
            <span style="color: #666666;">Read More</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Content 4 -->
   <div class="content-four-wrapper">
    <br/>
    <div class="form-wrapper">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe6-0usaDCkzg-g2bgt_LtpU6hQ8WKvRklFnuJgRfEHtA6SHg/viewform?embedded=true" width="100%" height="821" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>

    <div class="crane-img">
      <img class="logo" alt="LIFT EXPERTS" src="../assets/images/banner-bg-02.jpg"/>
    </div>
    
    <br/>
   </div>

  <!-- Content 5 -->
  <TheSponsor/>

  <!-- Copyright -->
  <TheCopyRight topBorder="copyrightClass"/>

</template>

<script>
// @ is an alias to /src
import TheHeader from '@/components/TheHeader.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'

export default {
  name: 'HomeView',
  components: {
    TheHeader,
    TheSponsor,
    TheCopyRight
  },
  data() {
    return {
      newsList: [
        {
          img: require('../assets/images/news/news-2025/9-july/news-2025-1.jpg'),
          date: 'MMCOA 09/07/2025',
          title: 'MMCOA (1987) Deputy President and Committee Member',
          link: '/news-event'
        },
        {
          img: require('../assets/images/news/news-2025/16-june/news-2025-1.jpg'),
          date: 'MMCOA 16/06/2025',
          title: 'Malaysia Heavy Construction Equipment Owners Association (MHCEOA)',
          link: '/news-event'
        },
        {
          img: require('../assets/images/news/news-2025/24-june/news-2025-1.jpg'),
          date: 'MMCOA 24/06/2025',
          title: 'Secretary General Goh Lian Chin representing MMCOA',
          link: '/news-event'
        }
      ]
    }
  }
}
</script>

<style scoped>
.main-banner-wrapper {
  /* background-color: skyblue; */
  height: 100vh;
  text-align: center;
  position: relative;
  background-image: url('@/assets/images/banner-bg-01.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.main-title-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.title-wrapper {font-size: 20px; line-height: 1.1;}
.button-wrapper {margin-top: 5%;}

.content-two-wrapper {
  text-align: center;
  padding: 2% 0;
  background-color: #e2e2e2;
  color: #666666;
}

.icn-wrapper {
  width: 80%;
  margin: 2% auto;
}
.icn-wrapper img{width: 100px;}

.content-three-wrapper {
  text-align: center;
  padding: 2% 0;
  color: #666666;
}
.news-wrapper img {height: 200px;}
.news-style{text-align: center; font-size: 14px; margin-bottom: 20px;}
.front-news {margin: 6px auto; max-width: 350px;}
.news-btn a {text-decoration: none;}

.content-four-wrapper{
  background-color: #e2e2e2;
}

.form-wrapper {
  width: 100%;
  text-align: center;
}

.crane-img {
  width: 100%;
  display: none;
}

@media (max-width: 842px) {
  :deep(.nav-wrapper){
    /* background-color: #e2e2e2; */
    text-align: left;
  }
  :deep(.nav-wrapper span){
    color: black;
  }
  :deep(.burger span){
    background-color: white;
  }
}

@media screen and (min-width: 570px) {
  .button-wrapper {
    display: flex;
    gap: 40px;
    justify-content: center;
    margin-top: 1%;
  }
}

@media screen and (min-width: 640px) {
  .title-wrapper {font-size: 30px;}
  .about-icn-wrapper, .news-wrapper{
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .icn-wrapper {width: 50%;}
  .news-wrapper {gap: 40px; width: 100%; margin-bottom: 0}
  /* .news-wrapper img {height: 260px;} */
  .news-style{text-align: left; margin-bottom: 0;}
}

@media screen and (min-width: 768px) {
  .icn-wrapper {width: 33%;}
  .icn-wrapper img{width: 150px;}
  .news-wrapper {gap: 80px;}
  .front-news {margin: 6px 0;}
}

@media screen and (min-width: 1024px) {
  .news-wrapper img {height: 200px;}

  .content-four-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
  }
  .form-wrapper {
    width: 50%;
  }
  .crane-img {
    width: 50%;
    display: block;
  }
  .content-four-wrapper img {
    width: 100%;
  }
}

@media screen and (min-width: 1280px) {
  .title-wrapper {font-size: 40px;}
  .news-wrapper img {height: 260px;}
}

</style>
